import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineAddCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M6 11.119A5.119 5.119 0 1 0 6 .882a5.119 5.119 0 0 0 0 10.237M6 3.638v4.725M3.638 6h4.725" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineAddCircle;
